import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getPostsByCategoryId = async(categoryId: string) => {
  const url = `${generateEndpoint('getPostsByCategoryId')}?categoryId=${categoryId}`
  return fetchGet(url, null)
}